
import React, { useState, useEffect } from 'react';
import './App.css';
import Swal from 'sweetalert2';
const ethers = require("ethers");

const CONTRACT_ADDRESS = "0x93FDB5323D44f14F1456DBADb0Ebe3ab1D2e25db";
const USDT_ADDRESS = "0x55d398326f99059fF775485246999027B3197955";


const ABI =[
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "usdtAmount",
				"type": "uint256"
			}
		],
		"name": "buyTokens",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "_saleDuration",
				"type": "uint256"
			}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			}
		],
		"name": "OwnableInvalidOwner",
		"type": "error"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "OwnableUnauthorizedAccount",
		"type": "error"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "previousOwner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
		],
		"name": "OwnershipTransferred",
		"type": "event"
	},
	{
		"inputs": [],
		"name": "renounceOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "buyer",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "TokensPurchased",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "newOwner",
				"type": "address"
			}
		],
		"name": "transferOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "withdrawUnsoldTokens",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "withdrawUSDT",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"name": "contributions",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "MAX_PURCHASE",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "owner",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "saleEndTime",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "TOKEN_PRICE",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "usdtToken",
		"outputs": [
			{
				"internalType": "contract IERC20",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "yuckBuckToken",
		"outputs": [
			{
				"internalType": "contract IERC20",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
];


const TOKEN_RATE = 0.10; // 1 YBK = 0.10 USDT

function App() {
    const [account, setAccount] = useState('');
    const [usdtAmount, setUsdtAmount] = useState('');
    const [ybkAmount, setYbkAmount] = useState('0'); // YBK to be bought
    const [saleEndTime, setSaleEndTime] = useState(0);
    const [timeLeft, setTimeLeft] = useState('');
    const [isSaleActive, setIsSaleActive] = useState(false);
    const [contract, setContract] = useState(null);
    const [usdtContract, setUsdtContract] = useState(null);
    const [isApproved, setIsApproved] = useState(false);

	const BNB_CHAIN_ID = "0x38"; // Binance Smart Chain Mainnet ID
	const BNB_RPC_URL = "https://bsc-dataseed.binance.org/"; // BSC Mainnet RPC URL
	const BNB_CHAIN_NAME = "Binance Smart Chain";
	const BNB_SYMBOL = "BNB";
	const BNB_DECIMALS = 18;
	const BNB_BLOCK_EXPLORER = "https://bscscan.com/";
	
	const connectWallet = async () => {
		if (window.ethereum) {
			try {
				const provider = new ethers.BrowserProvider(window.ethereum);
				const signer = await provider.getSigner();
				const userAddress = await signer.getAddress();
	
				// Check if the user is connected to the Binance Smart Chain
				const network = await provider.getNetwork();
				if (network.chainId !== parseInt(BNB_CHAIN_ID, 16)) {
					// Prompt to switch to BNB Smart Chain
					await switchToBnbChain();
				}
	
				setAccount(userAddress);
	
				const presaleContract = new ethers.Contract(CONTRACT_ADDRESS, ABI, signer);
				setContract(presaleContract);
	
				const usdtContractInstance = new ethers.Contract(
					USDT_ADDRESS,
					[
						"function approve(address spender, uint256 amount) public returns (bool)",
						"function allowance(address owner, address spender) public view returns (uint256)",
					],
					signer
				);
				setUsdtContract(usdtContractInstance);
	
				const endTime = await presaleContract.saleEndTime();
				const numericEndTime = Number(endTime);
				setSaleEndTime(numericEndTime);
				checkSaleStatus(numericEndTime);
	
				const allowance = await usdtContractInstance.allowance(userAddress, CONTRACT_ADDRESS);
				const bigAllowance = ethers.toBigInt(allowance);
				setIsApproved(bigAllowance > 0n);
			} catch (error) {
				console.error("Error connecting wallet:", error);
				Swal.fire({
					title: 'Connection Failed',
					text: 'Failed to connect wallet. Please ensure you are connected to the Binance Smart Chain network.',
					icon: 'error',
					confirmButtonText: 'Close',
				});
			}
		} else {
			Swal.fire({
				title: 'MetaMask Not Installed',
				text: 'Please install MetaMask to connect your wallet.',
				icon: 'warning',
				confirmButtonText: 'Close',
			});
		}
	};
	
	const switchToBnbChain = async () => {
		try {
			await window.ethereum.request({
				method: 'wallet_switchEthereumChain',
				params: [{ chainId: BNB_CHAIN_ID }],
			});
		} catch (error) {
			if (error.code === 4902) {
				// Chain not added to the user's wallet; add it
				try {
					await window.ethereum.request({
						method: 'wallet_addEthereumChain',
						params: [
							{
								chainId: BNB_CHAIN_ID,
								chainName: BNB_CHAIN_NAME,
								rpcUrls: [BNB_RPC_URL],
								nativeCurrency: {
									name: BNB_SYMBOL,
									symbol: BNB_SYMBOL,
									decimals: BNB_DECIMALS,
								},
								blockExplorerUrls: [BNB_BLOCK_EXPLORER],
							},
						],
					});
				} catch (addError) {
					console.error("Error adding Binance Smart Chain:", addError);
					Swal.fire({
						title: 'Network Error',
						text: 'Failed to add Binance Smart Chain to your wallet.',
						icon: 'error',
						confirmButtonText: 'Close',
					});
				}
			} else {
				console.error("Error switching network:", error);
				Swal.fire({
					title: 'Network Error',
					text: 'Failed to switch to Binance Smart Chain. Please try manually.',
					icon: 'error',
					confirmButtonText: 'Close',
				});
			}
		}
	};
	

    const calculateYBKAmount = (usdtAmount) => {
        if (usdtAmount && !isNaN(usdtAmount)) {
            const ybk = (parseFloat(usdtAmount) / TOKEN_RATE).toFixed(2);
            setYbkAmount(ybk);
        } else {
            setYbkAmount('0');
        }
    };

    const approveTokens = async () => {
        if (usdtContract && account && usdtAmount) {
            try {
                const usdtWei = ethers.parseUnits(usdtAmount, 18);
                const tx = await usdtContract.approve(CONTRACT_ADDRESS, usdtWei);
                await tx.wait();
                setIsApproved(true);
                Swal.fire({
                    title: 'Approval Successful!',
                    text: 'You have approved USDT for the presale.',
                    icon: 'success',
                    confirmButtonText: 'Close',
                });
            } catch (error) {
                console.error("Approval Failed:", error);
                Swal.fire({
                    title: 'Approval Failed',
                    text: 'There was an issue with token approval.',
                    icon: 'error',
                    confirmButtonText: 'Close',
                });
            }
        } else {
            Swal.fire({
                title: 'Missing Information',
                text: 'Please enter a valid amount.',
                icon: 'warning',
                confirmButtonText: 'Close',
            });
        }
    };

    const buyTokens = async () => {
		if (contract && account && usdtAmount) {
			try {
				const usdtWei = ethers.parseUnits(usdtAmount, 18); // Convert USDT to Wei
				const tx = await contract.buyTokens(usdtWei); // Call the contract's buyTokens function
				await tx.wait(); // Wait for the transaction to be mined
				Swal.fire({
					title: 'Success!',
					text: 'Your token purchase was successful!',
					icon: 'success',
					confirmButtonText: 'Close',
				});
			} catch (error) {
				console.error("Error buying tokens:", error);
	
				let errorMessage = 'There was an issue with the transaction. Please try again.';
				if (
					error?.reason?.includes('transfer amount exceeds balance') ||
					error?.data?.includes('transfer amount exceeds balance')
				) {
					errorMessage = 'Insufficient USDT balance. Please check your wallet and try again.';
				}
	
				Swal.fire({
					title: 'Transaction Failed',
					text: errorMessage,
					icon: 'error',
					confirmButtonText: 'Close',
				});
			}
		} else {
			Swal.fire({
				title: 'Wallet Not Connected',
				text: 'Please connect your wallet to proceed.',
				icon: 'warning',
				confirmButtonText: 'Close',
			});
		}
	};


    const checkSaleStatus = (endTime) => {
        const now = Math.floor(Date.now() / 1000);
        setIsSaleActive(now < endTime);
        updateCountdown(endTime);
    };

	const MAX_USDT = 1000; // Maximum allowed USDT amount

	const handleUsdtInput = (value) => {
    if (value > MAX_USDT) {
        Swal.fire({
            title: 'Limit Exceeded',
            text: `You cannot buy more than $${MAX_USDT}. Please enter a valid amount.`,
            icon: 'warning',
            confirmButtonText: 'Close',
        });
        setUsdtAmount(''); // Reset the input if the limit is exceeded
        setYbkAmount('0'); // Reset the YBK amount
    } else {
        setUsdtAmount(value);
        calculateYBKAmount(value);
    }
	};


    const updateCountdown = (endTime) => {
        const now = Math.floor(Date.now() / 1000);
        const timeLeftInSeconds = endTime - now;
        if (timeLeftInSeconds > 0) {
            const hours = Math.floor(timeLeftInSeconds / 3600);
            const minutes = Math.floor((timeLeftInSeconds % 3600) / 60);
            const seconds = timeLeftInSeconds % 60;
            setTimeLeft(`${hours}h ${minutes}m ${seconds}s`);
        } else {
            setTimeLeft("Sale ended!");
            setIsSaleActive(false);
        }
    };

    useEffect(() => {
        if (saleEndTime) {
            const interval = setInterval(() => updateCountdown(saleEndTime), 1000);
            return () => clearInterval(interval);
        }
    }, [saleEndTime]);

    useEffect(() => {
        calculateYBKAmount(usdtAmount);
    }, [usdtAmount]);

    return (
        <div className="app">
            <header className="header">
                <h1>Yuck Buck Pre-Sale</h1>
                <img src="logo_.jpg" style={{ height: '50px', width: '50px', objectFit: 'cover' }} alt='Yuck Buck Pre-Sale' />
            </header>
            <div className="content">
                {account ? (
                    <>
                        <div className="wallet-info">
                            <p><strong>Connected Wallet:</strong> {account}</p>
                        </div>
                        <div className="timer">
                            <h3>Time Left: {timeLeft}</h3>
                        </div>
                        <div className="input-container">
                            <input
                                type="number"
                                placeholder="Enter USDT Amount"
                                value={usdtAmount}
                                onChange={(e) => handleUsdtInput(e.target.value)}
                            />
							<br/>
                            <p className="price" ><strong>You are buying:</strong> {ybkAmount} YBK</p>
                        </div>
                        {!isApproved ? (
                            <button onClick={approveTokens}>Approve USDT</button>
                        ) : (
                            <button onClick={buyTokens} disabled={!isSaleActive}>
                                {isSaleActive ? 'Buy Tokens' : 'Sale Ended'}
                            </button>
                        )}
                    </>
                ) : (
                    <button onClick={connectWallet}>Connect MetaMask</button>
                )}
            </div>
            <footer>
                <p>Powered by Yuck Buck © 2025</p>
            </footer>
        </div>
    );
}

export default App;
